module.exports = __webpack_public_path__ + "static/img/hzq0701.4c7587f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hzq0701.jpg
// module id = Bw+Y
// module chunks = 0